const GetTierNumber = (tierList) => {
  let resolutionInTierListArray = tierList.map((tierList) => tierList.resolution);
  let count = 0;
  for (let i = 0; i < resolutionInTierListArray.length; i++) {
    if (resolutionInTierListArray[i] !== '') {
      count++;
    }
  }
  return count;
};

function BitRateCalculation(tierList, audioTracks, camsQty) {
  const mbps = 1000 * 1000;
  let audioBitRate = 24 / (1 / 48000) / mbps;
  let bitRateTotal = 0;
  let tierBitRateTotal = 0;
  if (Array.isArray(tierList)) {
    tierBitRateTotal = tierList
      .map((item) => item.bit_rate)
      .reduce((accumulator, currentValue) => {
        if (currentValue === '') {
          currentValue = 0;
        }
        return accumulator + currentValue;
      }, 0);
    bitRateTotal = ((audioBitRate * audioTracks.value * `${GetTierNumber(tierList)}` + tierBitRateTotal) * camsQty.value) / 8;
    //convert to MBps
  } else {
    tierBitRateTotal = tierList.bit_rate;
    bitRateTotal = ((audioBitRate * audioTracks.value + tierBitRateTotal) * camsQty.value) / 8;
  }

  return bitRateTotal;
}

export default BitRateCalculation;
